export default __webpack_public_path__ + "static/media/fol_vol.b09749b6.png";